module.exports = __webpack_public_path__ + "img/datasets.374732ed.png";